'use client';

import { useQuery } from '@tanstack/react-query';
import useIsMainnet from '../useIsMainnet';
import { getRetryDelayFn } from '../../utils/query/retryDelay';

const kySolApiId = '2r8NaP6G69vb1AgkWWLGQ8SVZLAcwXgWuq19a3zWo9gN';
const fragSolApiId = 'F9wJFGXiNgUVKdZtw4Lpq5icGPRoXWUjmCSZ8H3yrRA8';

type EXPONENT_API_RESPONSE = {
	data: Array<{
		id: string;
		stats: {
			ytImpliedRateAnnualizedPct: number;
		};
	}>;
};

export interface ExponentLstData {
	kySolApy: number;
	fragSolApy: number;
}

export const useExponentLstFetch = () => {
	const isMainnet = useIsMainnet();

	return useQuery({
		queryKey: ['exponentLstApy'],
		queryFn: async (): Promise<ExponentLstData> => {
			const response = await fetch(
				`https://web-api.exponent.finance/api/markets`
			);
			if (!response.ok) {
				throw new Error(`Failed to fetch Exponent metrics: ${response.status}`);
			}

			const data = (await response.json()) as EXPONENT_API_RESPONSE;
			const kySolData = data.data.find((mkt) => mkt.id === kySolApiId);
			const fragSolData = data.data.find((mkt) => mkt.id === fragSolApiId);

			const kySolApy =
				(kySolData?.stats?.ytImpliedRateAnnualizedPct ?? 0) * 100;
			const fragSolApy =
				(fragSolData?.stats?.ytImpliedRateAnnualizedPct ?? 0) * 100;

			return {
				kySolApy,
				fragSolApy,
			};
		},
		enabled: isMainnet,
		staleTime: 10 * 60 * 1000, // 10 minutes
		retryDelay: getRetryDelayFn(2000),
		retry: 3,
	});
};
